import { SmartLink } from "@selector/shared/components";
import { type FC } from "react";

import { ENTITY_TYPE, UNKNOWN_GENOME_NAME } from "@/settings/settings.js";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const BlastGenomeCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value || props.value === UNKNOWN_GENOME_NAME) {
    return null;
  }

  return (
    <TableCell>
      <SmartLink to={`/${ENTITY_TYPE.ORGANISM}/${props.data.target.organism.id}`} tooltip={props.value}>
        {props.value}
      </SmartLink>
    </TableCell>
  );
};

export { BlastGenomeCell };
export default BlastGenomeCell;
